import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

// REDUX
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as commonActions from '../../../actions/commonActions'
import * as userActions from '../../../actions/userActions'
import * as courseActions from '../../../actions/courseActions'

// CHILDREN
import ProgramRow from '../ProgramBuilderOld/ProgramRow'
import Pagination from '../../common/Pagination'
import Loader from '../../common/loader/legacy-loaders/Op36Loader-web'

// ASSETS
import './ProgramMarketplaceFlow.scss'

class ProgramMarketPlaceFlow extends Component {
  state = {
    programLoader: false,
    perPage: 10,
    activeProgramsSelected: true,
  }

  componentDidMount() {
    this._loadPrograms(1)
  }

  render() {
    const { pages, t } = this.props

    return (
      <div
        id='ProgramMarketplaceContainer'
        className='col-md-6 mx-auto animated fadeIn'
      >
        <div className='d-flex justify-content-center'>
          <button
            className='d-flex justify-content-center align-items-center switchButton'
            onClick={this._toggleProgramsType}
          >
            <div
              className={`switchOption ${this.state.activeProgramsSelected && 'switchSelected'}`}
            >
              {t('programs.copy.marketplaceFlow.active')}
            </div>
            <div
              className={`switchOption ${!this.state.activeProgramsSelected && 'switchSelected'}`}
            >
              {t('programs.copy.marketplaceFlow.completed')}
            </div>
          </button>
        </div>
        <div className='available-programs-container'>
          {this._renderPrograms()}
        </div>
        {pages > 1 && (
          <div className='row animated fadeIn'>
            <Pagination pageCount={pages} fetchData={this._loadPrograms} />
          </div>
        )}
      </div>
    )
  }

  _toggleProgramsType = () => {
    this._loadPrograms(1, !this.state.activeProgramsSelected)
    this.setState({ activeProgramsSelected: !this.state.activeProgramsSelected })
  }

  _loadPrograms = (page, type = null) => {
    const { user, user_actions } = this.props
    const { perPage } = this.state
    const programsType = type ?? this.state.activeProgramsSelected ? null : 'completed'
    this.setState({ programLoader: true }, () => {
      if (user.type === 'Admin') {
        user_actions
          .getUserCourses(user.id, 'admin', page, perPage)
          .then(() => this.setState({ programLoader: false }))
      } else {
        this.setState({ programLoader: true })
        user_actions
          .getUserCourses(
            user.communities[0].id,
            programsType,
            page,
            perPage,
            null
          )
          .then(() => {
            this.setState({ programLoader: false })
          })
      }
    })
  }

  _viewProgram = program => {
    const { onSelectedProgram } = this.props

    onSelectedProgram(program)
  }

  _renderPrograms = () => {
    const { user, courses, completed_courses, t } = this.props
    const { programLoader } = this.state

    if (programLoader) {
      return (
        <div className='col-md-6 mx-auto animated fadeIn template-loader-container'>
          <Loader message={t('programs.copy.marketplaceFlow.loadingPrograms')} />
        </div>
      )
    }
    const programs = this.state.activeProgramsSelected ? courses : completed_courses
    if (programs && programs.length > 0) {
      return programs.map((template, index) => (
        <ProgramRow
          program={template}
          viewProgram={this._viewProgram}
          user={user}
          key={index}
        />
      ))
    }
  }
}

ProgramMarketPlaceFlow.propTypes = {
  onSelectedProgram: PropTypes.func.isRequired,
  user: PropTypes.shape({
    communities: PropTypes.array,
    id: PropTypes.number,
    type: PropTypes.string,
  }),
  push: PropTypes.func,
  selectTemplate: PropTypes.func,
  user_actions: PropTypes.shape({
    refreshCurrentUser: PropTypes.func,
    getUserCourses: PropTypes.func,
  }),
  courses: PropTypes.array,
  completed_courses: PropTypes.array,
  pages: PropTypes.number,
  t: PropTypes.func,
}

function mapStateToProps(state) {
  return {
    ui: state.ui,
    user: state.user.current_user,
    courses: state.courses.courses,
    completed_courses: state.courses.completed_courses,
    archived_courses: state.courses.archived_courses,
    template_courses: state.courses.template_courses,
    featured_courses: state.courses.featured_courses,
    pages: state.pages,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    common_actions: bindActionCreators(commonActions, dispatch),
    course_actions: bindActionCreators(courseActions, dispatch),
    user_actions: bindActionCreators(userActions, dispatch),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(ProgramMarketPlaceFlow))
